@if (active) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="icons.section"></fa-icon>
          <span>{{ title }}</span>
        </h3>
        <button class="close-btn" (click)="onClose()">
          <fa-icon [icon]="icons.cancel"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <form (ngSubmit)="onSubmit()">
          <div class="form-group">
            <app-input class="section-name-input" [control]="control"
              [placeholder]="'DESCRIPTIONS_FORM.INSERT_SECTION_NAME' | translate"
              [label]="'DESCRIPTIONS_FORM.SECTION_NAME' | translate">
            </app-input>
          </div>
          <div class="form-actions">
            <app-button (clicked)="onClose()" variant="secondary" 
              [text]="'BUTTON.CANCEL' | translate">
            </app-button>
            <app-button [disabled]="control.invalid" (clicked)="onSubmit()" variant="primary"
              [text]="'DESCRIPTIONS_FORM.SAVE' | translate">
            </app-button>
          </div>
        </form>
      </div>
    </div>
  </div>
}